export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8088.18a92014.jpg";